var render = function () {
  var _vm$cash$amount, _vm$cash$amount$forma;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-snackbar', {
    attrs: {
      "bottom": "",
      "light": ""
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function fn(_ref) {
        var attrs = _ref.attrs;
        return [_c('v-btn', _vm._b({
          attrs: {
            "color": "red",
            "text": ""
          },
          on: {
            "click": function click($event) {
              _vm.shows = false;
            }
          }
        }, 'v-btn', attrs, false), [_c('v-icon', [_vm._v("mdi-close")])], 1)];
      }
    }]),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('span', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v(" " + _vm._s((_vm$cash$amount = _vm.cash.amount) === null || _vm$cash$amount === void 0 ? void 0 : (_vm$cash$amount$forma = _vm$cash$amount.format) === null || _vm$cash$amount$forma === void 0 ? void 0 : _vm$cash$amount$forma.call(_vm$cash$amount)) + "원이 적립되었습니다. ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }